import { withInstall } from "@xplus/utils/with-install";
import datePicker from "./src/date-picker.vue";
export const xDatePicker = withInstall(datePicker);
export default xDatePicker;
export * from "./src/date-picker";
